import React from 'react';
import { Routes, Route, Navigate ,useLocation } from 'react-router-dom';
import ReklamationList from './ReklamationList';
import ReklamationForm from './ReklamationForm';
import ReklamationDetail from './ReklamationDetail';

const ReklamationRoutes = () => {
  const { state } = useLocation();
  const ANR = state?.ANR ?? '';  // fallback if someone types URL by hand
  return (
    <Routes>
      <Route path="/" element={<ReklamationList />} />
      <Route path="/new" element={<ReklamationForm ANR={ANR} />} />
      <Route path="/edit/:id" element={<ReklamationForm />} />
      <Route path="/:id" element={<ReklamationDetail />} />
      {/* Fallback route */}
      <Route path="*" element={<Navigate to="/reklamation" />} />
    </Routes>
  );
};

export default ReklamationRoutes;